import { signal } from 'services/SignalsService'
import { SpinCheckService } from 'services/SpinCheckService'
import { subscribe } from 'utils/Subscribe'

const types = {
  400: 'sessionExpired',
  423: 'sessionExpired',
  424: 'sessionExpired',
}

const buttons = {
  'BUTTON:ok': () => {
    signal.dispatch('POPUP:close')
  },
  'BUTTON:adjust': () => {
    SpinCheckService.selectNear()
    signal.dispatch('POPUP:close')
  },
  'BUTTON:reload': () => {
    window.top.location.href = game.models.GameModel.home
  },
  'BUTTON:err': () => {
    window.top.location.href = game.models.GameModel.home
  },
  'BUTTON:deposit': () => {
    window.top.location.href = game.models.GameModel.deposit
  },
}

function status(code) {
  show(types[code] || 'serverError')
}

function show(value) {
  signal.dispatch('POPUP:show', value)
}

function init() {
  Object.entries(buttons).forEach(subscribe)
}

export const PopupManager = {
  init,
  show,
  status,
}
